<template>
    <BaseCard
        class="overflow-hidden !p-0"
        :to="to"
        data-spec-class="card-list"
    >
        <div
            v-if="$slots.default"
            :class="{
                'flex items-center gap-x-4 bg-surface--light p-6': true,
            }"
        >
            <div
                :class="{
                    'leading-6 font-medium': true,
                    'text-xl font-medium': size === CardListSize.Normal,
                    'text-sm': size === CardListSize.Small,
                }"
            >
                <slot></slot>
            </div>

            <Menu
                v-if="$slots.actions"
                as="div"
                class="relative ml-auto"
            >
                <MenuButton
                    class="-m-2.5 block p-2.5 text-tertiary hover:text-primary"
                    data-spec-class="card-list__menu-toggle"
                >
                    <span class="sr-only">Open options</span>
                    <EllipsisHorizontalIcon
                        class="h-8 w-8"
                        aria-hidden="true"
                    />
                </MenuButton>
                <transition
                    enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95"
                >
                    <MenuItems
                        class="absolute right-0 z-10 mt-0.5 w-48 origin-top-right rounded-md bg-surface py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-hidden dark:ring-gray-700"
                    >
                        <slot name="actions"> </slot>
                    </MenuItems>
                </transition>
            </Menu>
        </div>
        <dl
            v-if="!!$slots.list"
            :class="{
                '-my-3 divide-y divide-divider bg-surface px-6 py-4 leading-6': true,
                'text-sm': size === CardListSize.Small,
            }"
        >
            <slot name="list"></slot>
        </dl>
    </BaseCard>
</template>

<script setup lang="ts">
import { EllipsisHorizontalIcon } from '@heroicons/vue/24/outline';
import { Menu, MenuButton, MenuItems } from '@headlessui/vue';
import { RouteLocationNormalized } from 'vue-router';
import { CardListSize } from '@/types';

interface Props {
    to?: RouteLocationNormalized;
    size?: CardListSize;
}

withDefaults(defineProps<Props>(), {
    to: undefined,
    size: CardListSize.Small,
});
</script>
